export default {
    text: {
        facebook: `Renseignez votre fanpage Facebook pour avoir accès à vos statistiques`,
        twitter: `Renseignez votre compte Twitter pour avoir accès à vos statistiques`,
        instagram: `Ajouter un compte Instagram`,
        youtube: `Renseignez votre chaîne Youtube pour avoir accès à vos statistiques`,
        tiktok: `Renseignez votre compte Tiktok pour avoir accès à vos statistiques`,
    },
};
